import { Component } from '@angular/core';

@Component({
  selector: 'lib-deepak-spinner-test',
  template: `
    <p>
      deepak-spinner-test works!
    </p>
  `,
  styles: [
  ]
})
export class DeepakSpinnerTestComponent {

}
